import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core'; 
import TextField from '@mui/material/TextField';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [dataLoading, setDataLoading] = React.useState(false);

  const [keywordId, setKeywordId] = React.useState(0);

  const [pageHeading, setPageHeading] = React.useState("");
  const [titleMeta, setTitleMeta] = React.useState("");
  const [descriptionMeta, setDescriptionMeta] = React.useState("");
  const [keywordsMeta, setKeywordsMeta] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    setPageHeading("");
    setTitleMeta("");
    setDescriptionMeta("");
    setKeywordsMeta("");
    if(props.dataObj && props.dataObj.autoId){	      
      setKeywordId(props.dataObj.autoId);
      getApiData(props.dataObj.autoId);
    }else{
      setKeywordId(0);
    }
	}, [props.dataObj,open]);

  async function getApiData(kid){ 
    let apiUrl=API_URL+'/crm-keywords-association?id='+kid;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'uid': props.userObj.loginId,
				'fullName': props.userObj.fullName,
				'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    setDataLoading(true);
    await axios(config)
       .then(response => {
      setDataLoading(false);
      if(response && response.data && response.data.responseTxt==="success"){  
         
         if(response.data.list && response.data.list.length>0){
            setPageHeading(response.data.list[0].pageHeading);
            setTitleMeta(response.data.list[0].titleMeta);
            setDescriptionMeta(response.data.list[0].descriptionMeta);
            setKeywordsMeta(response.data.list[0].keywordsMeta);

         }	

      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      }
      
    })
  }


	function saveData(){
    // if(!keyword){
    //   setSeverityAlert("error");
    //   setShowAlert(true);
    //   setAlertMessage("Enter keyword");			
    //   return false;
    // }
    
		if(keywordId && keywordId>0){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }

      data.append('keywordId', keywordId);
      data.append('pageHeading', pageHeading);
      data.append('titleMeta', titleMeta);
      data.append('descriptionMeta', descriptionMeta);
      data.append('keywordsMeta', keywordsMeta);
      
      let apiURL='/crm-update-keywords-association';
      let myMessage="Keyword Association has been saved.";
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){          
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          window.location.reload();	
					return false;

        }else if(response.data.responseTxt==="invalidtoken"){
            window.location.href='invalidtoken';
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This data could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}
  

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
          {dataLoading?<LinearProgress />:null}            
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(pageHeading && pageHeading.length>0)?<>Edit</>:<>New</>} Keyword Association Info</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Page Heading</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setPageHeading(event.target.value)} value={pageHeading} placeholder={'Enter page heading'} fullWidth variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Meta Title</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setTitleMeta(event.target.value)} value={titleMeta} placeholder={'Enter meta title'} fullWidth variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Meta Description</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setDescriptionMeta(event.target.value)} value={descriptionMeta} placeholder={'Enter meta description'} fullWidth variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Meta Keywords</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setKeywordsMeta(event.target.value)} value={keywordsMeta} placeholder={'Enter meta keywords'} fullWidth variant="standard" />
                            </td>                            
                        </tr>

                      </table>
                      
                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;